import { cashbackPercent, orderBrands } from "./cashbackOrdering";

// Rank only the loaded home selection; never imply a ranking of the entire catalog.
export function discoverCashback(groups) {
  const brands = new Map();
  groups.flat().forEach(brand => {
    if (brand?.id != null && !brands.has(String(brand.id))) brands.set(String(brand.id), brand);
  });
  return orderBrands([...brands.values()].filter(brand => {
    const percent = cashbackPercent(brand);
    return percent > 0 && percent <= 100;
  })).slice(0, 6);
}
